/**
 * File: useCrmGlanceController.ts
 * Path: apps/admin/src/features/menu/hooks/useCrmGlanceController.ts
 * Description: The CRM line on a section's page: follow-ups due today and the open pipeline.
 */

import { todayInSouthAfrica } from "@idk/config";
import { useLeadsList } from "@/shared/hooks/useLeadsQueries";
import { summarisePipeline } from "@/shared/utils/pipelineUtils";
import { crmGlanceText } from "@/features/menu/utils/glanceUtils";

export const useCrmGlanceController = () => {
  const { data, isLoading, error } = useLeadsList();
  if (isLoading || error || !data) return { text: null };
  return { text: crmGlanceText(summarisePipeline(data, todayInSouthAfrica())) };
};
